import { loadBoundCardsApi } from '../../api/load-bound-cards';
import { ApiHost, BankCard, LoadCardsOptions, SbpToken } from '../../types';

import { normalizeMethods } from './utils';

export type { LoadCardsOptions };

export async function loadCards(
    apiHost: ApiHost,
    options?: LoadCardsOptions & { loadSbpTokens?: false },
): Promise<BankCard[]>;
export async function loadCards(apiHost: ApiHost, options: LoadCardsOptions): Promise<Array<BankCard | SbpToken>>;

export async function loadCards(apiHost: ApiHost, options: LoadCardsOptions = {}) {
    const cards = await loadBoundCardsApi(apiHost, options.serviceToken, options.loadSbpTokens);

    return normalizeMethods(cards);
}
